import React, {memo, useState} from 'react'
import {Container, Dropdown, Label, Menu} from 'semantic-ui-react'
import {goTo, userAccount, userIsAdmin, userIsAuthenticated, userIsBillingOwner} from '../../util'
import {withErrorHandling, withNavigation, withNotificationsData, withPropsPresent} from '../../hoc'
import {activateAccount, logout} from '../../backend'
import {isMobile} from '../../util'

const _TopNav = (
  {
    me = {accounts: [], activateAccount: {backupsEnabled: false}},
    location,
    navigate,
    goTo,
    logout,
    activateAccount,
    totalNotificationsCount,
    basePath = '/c'
  }
) => {
  const [loading, setLoading] = useState(false)

  const isActivePath = (path) => {
    return location.href.endsWith(path)
  }

  const onSignOut = async () => {
    await logout()
    location.href = `${basePath}/auth/login`
  }

  const onAccountSelected = async (account) => {
    setLoading(true)
    await activateAccount(account.id)
    setLoading(false)
    location.href = `${basePath}/services`
  }

  const onOpenHelp = (e) => {
    e.preventDefault()
    e.stopPropagation()
    navigate(`/c/help`)
  }

  const onOpenDocs = (e) => {
    e.preventDefault()
    e.stopPropagation()
    navigate('/c/docs/getting-started')
  }

  const onOpenLogin = (e) => {
    e.preventDefault()
    e.stopPropagation()
    navigate('/c/auth/login')
  }

  let account = userAccount(me)
  const unselectedAccounts = me.accounts.filter(a => a.id !== account.id)
  account = me.superUserAccount || account
  const isAdmin = userIsAdmin(me)
  const isBillingOwner = userIsBillingOwner(me)
  const isAuthenticated = userIsAuthenticated(me)
  const isAcceptInvitation = location.pathname.indexOf('auth/accept-invitation') > -1
  const isLogin = location.pathname.indexOf('/login') > -1
  const isHelp = location.pathname.indexOf('/help') > -1
  const isDocs = location.pathname.indexOf('/docs') > -1
  const isNotifications = location.pathname.indexOf('/notifications') > -1

  return (
    <Menu borderless fixed='top' style={{height: '4.5rem'}} data-testid='top-nav'>
      <Container>
        <Menu.Item as='a' header onClick={() => goTo(`${process.env.REACT_APP_SITE_URL}`)} className="logo-title"
                   active={isActivePath('/')}>
          Service Mocks
        </Menu.Item>
        <Menu.Menu position='right'>
          {
            isAuthenticated && !isLogin && !isAcceptInvitation && (
              <Dropdown className='account-drop-down' item text={account.name} loading={loading}
                        closeOnChange={true}
                        data-testid='top-nav-menu'>
                <Dropdown.Menu>
                  <Dropdown.Header>Service</Dropdown.Header>
                  <Dropdown.Item as='a' onClick={() => navigate('/c/services')}
                                 data-testid='top-nav-mocks-menu-item'>
                    Mocks
                  </Dropdown.Item>
                  <Dropdown.Item as='a' onClick={() => navigate('/c/directory')}
                                 data-testid='top-nav-directory-menu-item'>
                    Directory
                  </Dropdown.Item>
                  <Dropdown.Divider/>
                  <Dropdown.Header>Manage</Dropdown.Header>
                  <Dropdown.Item as='a' onClick={() => navigate('/c/account')}
                                 data-testid='top-nav-account-menu-item'>
                    Your Account
                  </Dropdown.Item>
                  {
                    isAdmin && (
                      <>
                        <Dropdown.Item as='a' onClick={() => navigate('/c/account/users')}
                                       data-testid='top-nav-users-menu-item'>
                          Users
                        </Dropdown.Item>
                        {
                          isBillingOwner && (
                            <Dropdown.Item as='a' onClick={() => navigate('/c/account/billing')}
                                           data-testid='top-nav-billing-menu-item'>
                              Billing
                            </Dropdown.Item>
                          )
                        }
                        {
                          me.isSuperUser && (
                            <Dropdown.Item as='a' onClick={() => navigate('/c/su')}
                                           data-testid='top-nav-accounts-menu-item'>
                              Accounts (su)
                            </Dropdown.Item>
                          )
                        }
                      </>
                    )
                  }
                  <Dropdown.Item as='a' onClick={() => navigate('/c/account/activity')}
                                 data-testid='top-nav-activity-menu-item'>
                    Activity
                  </Dropdown.Item>
                  {
                    ((isAdmin && me.activeAccount.backupsEnabled) || (me.isSuperUser && me.superUserAccount && me.superUserAccount.backupsEnabled)) && (
                      <Dropdown.Item as='a' onClick={() => navigate('/c/account/backups')}
                                     data-testid='top-nav-backups-menu-item'>
                        Backups
                      </Dropdown.Item>
                    )
                  }
                  <Dropdown.Item as='a' onClick={() => navigate('/c/account/suggested-archives')}
                                 data-testid='top-nav-archives-menu-item'>
                    Archives
                  </Dropdown.Item>
                  {
                    unselectedAccounts.length > 0 && !me.superUserAccount && (
                      <>
                        <Dropdown.Divider/>
                        <Dropdown.Header>Switch Account</Dropdown.Header>
                      </>
                    )
                  }
                  {
                    unselectedAccounts.length > 0 && !me.superUserAccount && unselectedAccounts.map((a) => (
                      <Dropdown.Item key={a.id}
                                     data-testid='top-nav-switch-account-menu-item'
                                     onClick={() => onAccountSelected(a)}>
                        {a.name}
                      </Dropdown.Item>
                    ))
                  }
                  <Dropdown.Divider/>
                  <Dropdown.Item as='a' onClick={() => onSignOut()} data-testid='top-nav-logout-menu-item'>
                    Log Out
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )
          }
          {
            (!isAuthenticated && !isLogin && !isAcceptInvitation) && (
              <Menu.Item as='a' href='' onClick={onOpenLogin}>Login</Menu.Item>)
          }
          <Menu.Item as='a' onClick={onOpenDocs} active={isDocs} data-testid='top-nav-docs-item'>Docs</Menu.Item>
          <Menu.Item as='a' onClick={onOpenHelp} active={isHelp} data-testid='top-nav-help-item'>Help</Menu.Item>
        </Menu.Menu>
        {
          totalNotificationsCount > 0 && (
            <Menu.Item as='a' onClick={() => navigate('/c/notifications')} active={isNotifications}>
              <Label content={totalNotificationsCount} icon='alarm'/>
            </Menu.Item>
          )
        }
      </Container>
    </Menu>
  )
}

let TopNav = (props) => {
  const {handleError} = props
  props = {
    ...props,
    location: window.location,
    logout: handleError(logout),
    activateAccount: handleError(activateAccount),
    goTo: handleError(goTo)
  }
  return (<_TopNav {...props}/>)
}

TopNav = withPropsPresent(TopNav, ['me'])
TopNav = withNotificationsData(TopNav)
TopNav = withNavigation(TopNav)
TopNav = withErrorHandling(TopNav)
TopNav = memo(TopNav)

export {TopNav, _TopNav}

export default TopNav
